import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { Box, CircularProgress } from '@material-ui/core';

import { MultimediaValues } from '../../../../../features/multimedia/model/multimediaModel';
import SnackbarSettings from '../../../../Snackbar/SnackbarSettings/SnackbarSettings';
import * as Selectors from '../../../../../features/multimedia/redux/multimediaSelectors';
import * as Actions from '../../../../../features/multimedia/redux/multimediaActions';
import useMainProgressContext from '../../../../progress/MainProgress/context/MainProgressContext';
import DialogForm from '../../../base/DialogForm';
import Upload from '../../Upload';
import { TEXT_FIELD_COLOR } from '../../../enum/formProps';
import { API_REQUEST_STATE } from '../../../../../core/enums/apiRequestState';

import './UploadFileForm.scss';

const initialValues: MultimediaValues = {
  file: '',
};

const validationSchema = Yup.object().shape({
  file: Yup.mixed().required('validation.is_required'),
});

interface UploadFileFormProps {
  onSuccess: () => void;
  onClose: () => void;
  successMessage: string;
  buttonActionLabel: string;
}

const UploadFileForm: React.FC<UploadFileFormProps> = (props) => {
  const dispatch = useDispatch();
  const apiRequestState = useSelector(Selectors.apiMultimediaRequestState);
  const apiRequestError = useSelector(Selectors.apiMultimediaRequestError);
  const { show, hide } = useMainProgressContext();

  useEffect(() => {
    hide();
  }, []);

  return (
    <>
      <SnackbarSettings
        successMessage={props.successMessage}
        apiRequestState={apiRequestState}
        apiRequestError={apiRequestError}
        setApiRequestState={Actions.setApiMultimediaRequestState}
        onSuccess={props.onSuccess}
      />
      {apiRequestState !== API_REQUEST_STATE.LOADING && (
        <DialogForm
          buttonActionLabel={props.buttonActionLabel}
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values: MultimediaValues) => {
            show();
            dispatch(Actions.addMultimedia(values));
          }}
          onClose={props.onClose}
        >
          <Upload name="file" label="multimedia.file" color={TEXT_FIELD_COLOR.PRIMARY} hideLabel={true} />
        </DialogForm>
      )}
      {apiRequestState === API_REQUEST_STATE.LOADING && (
        <Box className="UploadFileForm-Box">
          <CircularProgress />
        </Box>
      )}
    </>
  );
};

export default UploadFileForm;
